import { createListenerMiddleware } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'
import configSlice from './config-slice'
import orderCurrencySlice from 'modules/order/state/currency/order-currency-slice'
import { paymentMethodsApi } from 'redux/services/paymentMethods'

export const configMiddleware = createListenerMiddleware<RootState>()

// Middleware that listens for currency changes and updates active payment methods
configMiddleware.startListening({
  actionCreator: orderCurrencySlice.actions.setValue,
  effect: async (action, listenerApi) => {
    const { config } = listenerApi.getState()

    try {
      // Fetch payment methods for the new currency
      const result = await listenerApi.dispatch(
        paymentMethodsApi.endpoints.getPaymentMethods.initiate({
          campaignId: config.campaignId,
          currency: action.payload,
        }),
      )

      // If the fetch was successful, update the active payment methods
      if (result.data?.paymentMethods) {
        listenerApi.dispatch(
          configSlice.actions.setActivePaymentMethods(result.data.paymentMethods),
        )
      }
    } catch (error) {
      console.error('Failed to fetch payment methods for currency change:', error)
    }
  },
})
